export default __webpack_public_path__ + "static/media/sec-2-btm.8fa769ad.png";